import {Button} from 'platform/components';

import {useDispatch} from 'react-redux';

import {useInspectionToInProgressMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {updateAuditState} from '../../store/carAudit/reducer';
import {LoadAuditDataResponseItemBody} from '../../types/LoadAuditDataResponseItemBody';

interface ReopenInspectionProps {
  inspectionId: string;
  handleBackButton: () => void;
}

export function ReopenInspection({
  inspectionId,
  handleBackButton,
  'data-testid': dataTestId,
}: ReopenInspectionProps & TestIdProps) {
  const [reopenInspection, reopenInspectionResponse] = useInspectionToInProgressMutation();
  const dispatch = useDispatch();

  const onInspectionReopen = async () => {
    try {
      await reopenInspection({inspectionId}).unwrap();
      dispatch(
        updateAuditState({
          state: LoadAuditDataResponseItemBody.state.IN_PROGRESS,
        })
      );
      handleBackButton();
    } catch (e: any) {
      handleApiError(e);
    }
  };
  return (
    <Button
      data-testid={suffixTestId('inspectionHeader', {'data-testid': dataTestId})}
      onClick={onInspectionReopen}
      isLoading={reopenInspectionResponse.isLoading}
      isDisabled={reopenInspectionResponse.isLoading}
      title={i18n.t('general.actions.reopen')}
    />
  );
}
